<template>
    <div class="map-background" :style="boxWrapStyleObj">
        <!--市级地图-->
        <div id="city_map" ref="cityMapRef" :style="mapStyleObj"></div>
        <div class="panel-box-wrap district-box" v-show="isShowProvince">
            <div class="close-btn">
                <img
                        class="logo-img"
                        src="../../../assets/images/map/close.png"
                        width="100%"
                        height="100%"
                        v-on:click="closeWin"
                />
            </div>
            <div class="panel-box">
                <div class="panel-left" ref="panelLeftRef">
                    <div id="district_map" ref="provinceMapRef" class="left-map"></div>
                </div>
                <div class="district-data-area">
                    <div
                            class="popup-item bubble"
                            v-for="(item, index) in districtDataList"
                    >
                        <div class="popup-item-text" :title="item.value">
                            <p class="p-num">
                                <count-up
                                        class="infor-card-count user-created-count"
                                        :id-name="'codes_' + item.name"
                                        :end-val="item.value"
                                        color="#0EFCFF"
                                        countSize="18"
                                        :countWeight="countWeight"
                                        :isConvert="isConvert"
                                >
                                </count-up>
                            </p>
                            <p>{{ item.name }}</p>
                        </div>
                    </div>
                </div>
                <div class="panel-right">
                    <div class="panel-head">
                        <div class="head-wrap">
                            <div class="right-mian" style="display: flex">
                                <input
                                        placeholder="请输入学校名称"
                                        class="input-cla"
                                        v-model="filters.keyWord"
                                        v-on:keyup.enter="handleSearch"
                                />
                                <div class="search-btn" v-on:click="handleSearch">
                                    <div class="search-icon">
                                        <img
                                                src="../../../assets/images/databoard/detailPage/search.png"
                                                width="100%"
                                                height="100%"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--按学校统计的学校使用情况列表-->
                    <div class="panel-table">
                        <div class="header">
                            <Col :span="3">
                            <span>排序</span>
                            </Col>
                            <Col :span="10">
                            <span>学校名称</span>
                            </Col>
                            <Col :span="3">
                            <span>学段</span>
                            </Col>
                            <Col :span="4">
                            <span>操作次数</span>
                            </Col>
                            <Col :span="4">
                            <span>班级数</span>
                            </Col>
                        </div>
                        <Row
                                class="row-wrap"
                                v-for="(item, index) in schoolUseData"
                                :key="item.id"
                        >
                            <Col :span="3" class="col-content">
                            <div
                                    class="sort-item orange-item"
                                    :class="
                    (pageParams.page - 1) * pageParams.limit + index++ < 3
                      ? 'orange-item'
                      : 'blue-item'
                  "
                            >
                  <span>{{
                    (pageParams.page - 1) * pageParams.limit + index++
                  }}</span>
                            </div>
                            </Col>
                            <Col :span="10" class="col-content">
                            <a
                                    :title="item.school_name"
                                    href="javascript:void(0);"
                                    v-on:click="lookSchoolDashBoard(item.id)"
                                    style="color: #2d8cf0"
                            >{{ item.school_name }}</a
                            >
                            </Col>
                            <Col :span="3" class="col-content">
                            <span>{{ item.phase }}</span>
                            </Col>
                            <Col :span="4" class="col-content">
                            <span>{{ item.ocount }}</span>
                            </Col>
                            <Col :span="4" class="col-content">
                            <span>{{ item.classCount }}</span>
                            </Col>
                        </Row>
                    </div>
                    <div class="bottom-page">
                        <div class="laypage_main">
                            <Page
                                    :total="pageParams.total"
                                    @on-change="handleCurrentChange"
                                    :current="pageParams.page"
                                    v-if="pageParams.total && pageParams.pageCount > 1"
                            ></Page>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--气泡1-->
        <div class="rate-popup rate-popup-one puer-popup-one" :title="'116'">
            <div class="rate-popup-item">
                <img
                        src="../../../assets/images/nanjindataboard/popup-ratate.png"
                        width="100%"
                        height="100%"
                        class="popup-img"
                />
                <div class="count">
          <span class="num">
            <count-up
                    class="infor-card-count user-created-count"
                    :id-name="'code_' + '学校总数'"
                    :end-val="116"
                    color="#0EFCFF"
                    countSize="18"
                    :countWeight="countWeight"
                    :isConvert="isConvert"
            >
            </count-up>
          </span>
                    <p>学校总数</p>
                </div>
            </div>
        </div>
        <!--气泡2-->
        <div class="rate-popup rate-popup-two puer-popup-two" :title="'1242'">
            <div class="rate-popup-item">
                <img
                        src="../../../assets/images/nanjindataboard/popup-ratate.png"
                        width="100%"
                        height="100%"
                        class="popup-img"
                />
                <div class="count">
          <span class="num">
            <count-up
                    class="infor-card-count user-created-count"
                    :id-name="'code_' + '班级总数'"
                    :end-val="1242"
                    color="#0EFCFF"
                    countSize="18"
                    :countWeight="countWeight"
                    :isConvert="isConvert"
            >
            </count-up>
          </span>
                    <p>班级总数</p>
                </div>
            </div>
        </div>
        <!--气泡3-->
        <div class="rate-popup rate-popup-three puer-popup-three" :title="'21536'">
            <div class="rate-popup-item">
                <img
                        src="../../../assets/images/nanjindataboard/popup-ratate.png"
                        width="100%"
                        height="100%"
                        class="popup-img"
                />
                <div class="count">
          <span class="num">
            <count-up
                    class="infor-card-count user-created-count"
                    :id-name="'code_' + '学生总数'"
                    :end-val="21536"
                    color="#0EFCFF"
                    countSize="18"
                    :countWeight="countWeight"
                    :isConvert="isConvert"
            >
            </count-up>
          </span>
                    <p>学生总数</p>
                </div>
            </div>
        </div>
        <!--气泡4-->
        <div class="rate-popup rate-popup-four puer-popup-four" :title="'6319'">
            <div class="rate-popup-item">
                <img
                        src="../../../assets/images/nanjindataboard/popup-ratate.png"
                        width="100%"
                        height="100%"
                        class="popup-img"
                />
                <div class="count">
          <span class="num">
            <count-up
                    class="infor-card-count user-created-count"
                    :id-name="'code_' + '教师总数'"
                    :end-val="6319"
                    color="#0EFCFF"
                    countSize="18"
                    :countWeight="countWeight"
                    :isConvert="isConvert"
            >
            </count-up>
          </span>
                    <p>教师总数</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDistrictSchoolList} from "../../../service/api";
    import CountUp from "../../../components/countUp.vue";

    export default {
        name: "city-map",
        components: {
            CountUp,
        },
        props: ['token'],
        data() {
            return {
                map: null,//南京地图
                //地图宽高
                mapStyleObj: {
                    width: "100%",
                    height: "100%",
                },
                boxWrapStyleObj: {
                    height: "0px",
                },
                countWeight: 700,
                isConvert: 1, //是否转换数字
                //显示二级区统计图
                isShowProvince: false,
                geoCoordMap: {},
                //数据信息
                data: [
                    {
                        name: "墨江哈尼族自治县",
                        code: 530822,
                        value: 0,
                        districtDataList: [
                            {
                                name: "学校总数",
                                value: 0,
                            },
                            {
                                name: "班级总数",
                                value: 0,
                            },
                            {
                                name: "教师总数",
                                value: 0,
                            },
                            {
                                name: "学生总数",
                                value: 0,
                            },
                        ],
                    },
                    {
                        name: "孟连傣族拉祜族佤族自治县",
                        code: 530827,
                        value: 0,
                        districtDataList: [
                            {
                                name: "学校总数",
                                value: 0,
                            },
                            {
                                name: "班级总数",
                                value: 0,
                            },
                            {
                                name: "教师总数",
                                value: 0,
                            },
                            {
                                name: "学生总数",
                                value: 0
                            },
                        ],
                    },
                    {
                        name: "宁洱哈尼族彝族自治县",
                        code: 530821,
                        value: 3,
                        districtDataList: [
                            {
                                name: "学校总数",
                                value: 3,
                            },
                            {
                                name: "班级总数",
                                value: 90,
                            },
                            {
                                name: "教师总数",
                                value: 95,
                            },
                            {
                                name: "学生总数",
                                value: 0,
                            },
                        ],
                    },
                    {
                        name: "思茅区",
                        code: 530802,
                        value: 6,
                        districtDataList: [
                            {
                                name: "学校总数",
                                value: 6,
                            },
                            {
                                name: "班级总数",
                                value: 31,
                            },
                            {
                                name: "教师总数",
                                value: 96,
                            },
                            {
                                name: "学生总数",
                                value: 1535,
                            },
                        ],
                    },
                    {
                        name: "景东彝族自治县",
                        code: 530823,
                        value: 1,
                        districtDataList: [
                            {
                                name: "学校总数",
                                value: 1,
                            },
                            {
                                name: "班级总数",
                                value: 0,
                            },
                            {
                                name: "教师总数",
                                value: 1,
                            },
                            {
                                name: "学生总数",
                                value: 0,
                            },
                        ],
                    },
                    {
                        name: "景谷傣族彝族自治县",
                        code: 530824,
                        value: 4,
                        districtDataList: [
                            {
                                name: "学校总数",
                                value: 4,
                            },
                            {
                                name: "班级总数",
                                value: 1,
                            },
                            {
                                name: "教师总数",
                                value: 5,
                            },
                            {
                                name: "学生总数",
                                value: 1,
                            },
                        ],
                    },
                    {
                        name: "江城哈尼族彝族自治县",
                        code: 530826,
                        value: 0,
                        districtDataList: [
                            {
                                name: "学校总数",
                                value: 0,
                            },
                            {
                                name: "班级总数",
                                value: 0,
                            },
                            {
                                name: "教师总数",
                                value: 0,
                            },
                            {
                                name: "学生总数",
                                value: 0,
                            },
                        ],
                    },
                    {
                        name: "澜沧拉祜族自治县",
                        code: 530828,
                        value: 0,
                        districtDataList: [
                            {
                                name: "学校总数",
                                value: 0,
                            },
                            {
                                name: "班级总数",
                                value: 0,
                            },
                            {
                                name: "教师总数",
                                value: 0,
                            },
                            {
                                name: "学生总数",
                                value: 0,
                            },
                        ],
                    },
                    {
                        name: "西盟佤族自治县",
                        code: 530829,
                        value: 0,
                        districtDataList: [
                            {
                                name: "学校总数",
                                value: 0,
                            },
                            {
                                name: "班级总数",
                                value: 0,
                            },
                            {
                                name: "教师总数",
                                value: 0,
                            },
                            {
                                name: "学生总数",
                                value: 0,
                            },
                        ],
                    },
                    {
                        name: "镇沅彝族哈尼族拉祜族自治县",
                        code: 530825,
                        value: 2,
                        districtDataList: [
                            {
                                name: "学校总数",
                                value: 2,
                            },
                            {
                                name: "班级总数",
                                value: 120,
                            },
                            {
                                name: "教师总数",
                                value: 122,
                            },
                            {
                                name: "学生总数",
                                value: 0,
                            },
                        ],
                    }
                ],
                //区域数据集合
                districtDataList: [
                    {
                        name: "学校总数",
                        value: 116,
                    },
                    {
                        name: "班级总数",
                        value: 1242,
                    },
                    {
                        name: "教师总数",
                        value: 1319,
                    },
                    {
                        name: "学生总数",
                        value: 11536,
                    },
                ],
                mapData: [],
                maxNum: 0,
                provinceMap: null, //省级地图
                provinceMapData: [],
                currentCode: "", //省code
                currentCityCode: "", //市code
                schoolUseData: [], //学校使用数据
                filters: {
                    keyWord: "",
                },
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0,
                },
            };
        },
        methods: {
            /**
             * 关闭弹窗
             */
            closeWin() {
                this.filters.keyWord = "";
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.provinceMapData = [];
                this.currentProvinceName = "";
                this.currentProvinceCode = "";
                this.currentCityCode = "";
                this.isShowProvince = false;
            },
            /**
             * 点击查看学校数据展板
             */
            lookSchoolDashBoard(schoolId) {
                let routeData = this.$router.resolve({
                    name: schoolId=='75047a8a0990480f8abf3a39bc25f1ab'?'cloudschooldataboard':"schooldataboard",
                    params: {
                        schoolId: schoolId
                    },
                    query:{
                        userid:this.userId,
                        tokenId:this.$store.getters.token
                    }
                });
                window.open(routeData.href, "_blank");
            },
            /**
             * 翻页
             */
            handleCurrentChange(val) {
                this.pageParams.page = val;
                this.queryDistrictSchoolList(this.currentCode);
            },
            /**
             * 查询
             */
            handleSearch() {
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.queryDistrictSchoolList(this.currentCode);
            },
            /**
             * 处理数据的函数,将经纬度,名称,value结合到一起放入series中的data中
             */
            convertData(data) {
                var res = [];
                for (var i = 0; i < data.length; i++) {
                    var geoCoord = this.geoCoordMap[data[i].name];
                    if (geoCoord) {
                        res.push({
                            name: data[i].name,
                            value: geoCoord.concat(data[i].value),
                        });
                    }
                }
                return res;
            },
            /**
             * 初始化普洱市地图
             */
            initCityMap() {
                let _this = this;
                var cityData = require("../../../../static/json/普洱市/普洱市.json");
                this.$echarts.registerMap("普洱市", cityData); //注册
                //获取市级下区域的经纬度
                var mapFeatures = this.$echarts.getMap("普洱市").geoJson.features;
                mapFeatures.forEach(function (v) {
                    // 地区名称
                    var name = v.properties.name;
                    // 地区经纬度
                    _this.geoCoordMap[name] = v.properties.centroid;
                });
                //配置样式
                var optionMap = {
                    tooltip: {
                        trigger: "item",
                        formatter: function (params) {
                            if (params.seriesType === "map") {
                                if (params.name == "") {
                                    return;
                                }
                                if (!isNaN(params.value)) {
                                    return params.name + " : " + params.value;
                                }
                            } else if (params.seriesType === "scatter") {
                                return params.name + " : " + params.value[2];
                            } else if (params.seriesType === "effectScatter") {
                                return params.name + " : " + params.value[2];
                            } else {
                                return "暂无数据";
                            }
                        },
                    },
                    geo: {
                        map: "普洱市",
                        zoom: 1.1,
                        roam: false,
                        top: "5%",
                        label: {
                            normal: {
                                show: false,
                                textStyle: {
                                    color: "#fff",
                                },
                            },
                            emphasis: {
                                show: false,
                                color: "#fff",
                            },
                        },
                        itemStyle: {
                            normal: {
                                areaColor: "#24CFF4",
                                borderColor: "#53D9FF",
                                borderWidth: 1.3,
                                shadowBlur: 15,
                                shadowColor: "rgb(58,115,192)",
                                shadowOffsetX: 7,
                                shadowOffsetY: 6,
                            },
                            emphasis: {
                                areaColor: "#8dd7fc",
                                borderWidth: 1.6,
                                shadowBlur: 25,
                            },
                        },
                    },
                    // 视觉映射组件
                    visualMap: {
                        min: 0,
                        max: _this.findMaxVal(_this.data),
                        left: "20%",
                        bottom: "12%",
                        text: ["高", "低"], // 文本，默认为数值文本
                        textStyle: {
                            color: "#fff",
                        },
                        calculable: true,
                        seriesIndex: [1],
                        inRange: {
                            color: ["#24CFF4", "#2E98CA", "#5e33ff"],
                        },
                    },
                    series: [
                        {
                            type: "effectScatter",
                            coordinateSystem: "geo",
                            geoIndex: 0,
                            data: _this.convertData(_this.data),
                            symbolSize: 12,
                            showEffectOn: "render",
                            rippleEffect: {
                                brushType: "stroke",
                            },
                            animation: true,
                            label: {
                                normal: {
                                    formatter: "{b}",
                                    position: "top",
                                    show: true,
                                    textStyle: {
                                        color: "#fff",
                                    },
                                },
                            },
                            itemStyle: {
                                normal: {
                                    color: "#f4e925",
                                    shadowBlur: 10,
                                    shadowColor: "#333",
                                },
                            },
                            zlevel: 1,
                        },
                        {
                            name: "categoryChina",
                            type: "map",
                            geoIndex: 0,
                            data: _this.data,
                        },
                    ],
                };
                let winHeight = window.innerHeight;
                if (winHeight < 900) {
                    winHeight = 938;
                }

                let boxWrapHeight = winHeight - 128 - 10;
                let contentHeight = boxWrapHeight - 20;
                this.boxWrapStyleObj.height = boxWrapHeight + "px";
                _this.$refs.cityMapRef.style.height = contentHeight + "px";
                var dom = document.getElementById("city_map");
                //得到echarts的实例对象
                _this.map = this.$echarts.init(dom);
                _this.map.setOption(optionMap);
                //点击弹出区地图
                _this.map.on("click", function (params) {
                    _this.pageParams.total = 0;
                    _this.pageParams.page = 1;
                    _this.pageParams.pageCount = 0;
                    for (let i = 0; i < _this.data.length; i++) {
                        if (_this.data[i].name == params.name) {
                            //动态加载区地图
                            let data = [];
                            data.push(_this.data[i]);
                            _this.initDistrictMap(params.name, data);
                            _this.currentCode = params.data.code;
                            _this.districtDataList = params.data.districtDataList;
                            _this.queryDistrictSchoolList(params.data.code);
                        }
                    }
                });
            },
            /**
             * 获取区域下的学校列表
             */
            queryDistrictSchoolList(code) {
                let _this = this;
                let params = {
                    province: 530000,
                    city: 530800,
                    districtId: code,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit,
                    keyWord: _this.filters.keyWord,
                };
                getDistrictSchoolList(params)
                    .then(function (res) {
                        let data = res.classCountList;
                        _this.handleData(data);
                        _this.pageParams.total = res.gradeTotal;
                        _this.pageParams.pageCount = Math.ceil(
                            res.gradeTotal / _this.pageParams.limit
                        );
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 处理数据
             */
            handleData(data) {
                for (let i = 0; i < data.length; i++) {
                    data[i].classCount = data[i].classCount + 2;
                }
                this.schoolUseData = data;
            },
            /**
             * 动态加载区地图
             */
            initDistrictMap(name, data) {
                let _this = this;
                var districtData = require("../../../../static/json/普洱市/district/" +
                    name +
                    ".json");
                this.$echarts.registerMap(name, districtData); //注册
                var mapFeatures = this.$echarts.getMap(name).geoJson.features;
                mapFeatures.forEach(function (v) {
                    // 地区名称
                    var name = v.properties.name;
                    // 地区经纬度
                    _this.geoCoordMap[name] = v.properties.center;
                });
                //配置样式
                this.optionMap = {
                    title: {
                        text: "普洱市" + name,
                        left: "20",
                        textStyle: {
                            color: "#0EFCFF",
                        },
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: function (params) {
                        },
                    },
                    geo: {
                        map: name,
                        roam: false,
                        top: "30%",
                        aspectScale: "1.2",
                        label: {
                            normal: {
                                show: false,
                                textStyle: {
                                    color: "#fff",
                                },
                            },
                            emphasis: {
                                show: false,
                                color: "#fff",
                            },
                        },
                        itemStyle: {
                            normal: {
                                areaColor: "#1e62ac",
                                borderColor: "#53D9FF",
                                borderWidth: 1.3,
                                shadowBlur: 15,
                                shadowColor: "rgb(58,115,192)",
                                shadowOffsetX: 7,
                                shadowOffsetY: 6,
                            },
                            emphasis: {
                                areaColor: "#8dd7fc",
                                borderWidth: 1.6,
                                shadowBlur: 25,
                            },
                        },
                    },
                    series: [
                        {
                            type: "effectScatter",
                            coordinateSystem: "geo",
                            geoIndex: 0,
                            data: _this.convertData(data),
                            symbolSize: 12,
                            showEffectOn: "render",
                            rippleEffect: {
                                brushType: "stroke",
                            },
                            animation: true,
                            label: {
                                normal: {
                                    formatter: "{b}",
                                    position: "top",
                                    show: true,
                                    textStyle: {
                                        color: "#fff",
                                    },
                                },
                            },
                            itemStyle: {
                                normal: {
                                    color: "#f4e925",
                                    shadowBlur: 10,
                                    shadowColor: "#333",
                                },
                            },
                            zlevel: 1,
                        },
                        {
                            name: "categoryChina",
                            type: "map",
                            geoIndex: 0,
                            data: data,
                        },
                    ],
                };
                var dom = document.getElementById("district_map");
                //得到echarts的实例对象
                var myChart = this.$echarts.init(dom);
                myChart.setOption(this.optionMap);
                _this.$nextTick(() => {
                    // 打开弹窗
                    _this.isShowProvince = true;
                });
            },
            /**
             * 获取最大数值
             */
            findMaxVal(data) {
                let curMaxNum = 0;
                for (var i = 0; i < data.length; i++) {
                    if (curMaxNum < data[i].value) {
                        curMaxNum = data[i].value;
                    }
                }
                return curMaxNum;
            }
        },
        mounted() {
            let _this = this;
            // 初始化市级地图
            _this.initCityMap();
            // 更新地图
            window.addEventListener('resize', function () {
                let winHeight = window.innerHeight;
                if (winHeight < 900) {
                    winHeight = 938;
                }
                let boxWrapHeight = winHeight - 128 - 10;
                let contentHeight = boxWrapHeight - 20;
                _this.boxWrapStyleObj.height = boxWrapHeight + "px";
                _this.$refs.cityMapRef.style.height = contentHeight + "px";
                _this.map.resize();
            });
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/databoard";
    @import "../../../style/map";

    .map-container {
        position: relative;
        box-sizing: border-box;
        padding: 0 22px 0 22px;
    }

    .panel-box {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin: 0 !important;
        background-image: url("../../../assets/images/map/box-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .map-background {
        background-image: url("../../../assets/images/nanjindataboard/bg1.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
    }

    .bubble {
        background-image: url("../../../assets/images/nanjindataboard/popup.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .popup-img {
        animation: rota 10s infinite linear;
        -webkit-animation: rota 10s infinite linear;
        -moz-animation: rota 10s infinite linear;
    }
</style>